import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../services/api/axios.config";
import { notify } from "../utils/methods/notification";
const initialState = {
  addModal: false,
  clonedModal: false,
  isLoading: false,
   fbTemplate: {
    items: []
    ,pagination:{}
  },
  templateExit:[],
  versions:[],
  timeline:[],
  templateDropdownlist:[],
  incrementTemplateData:[],
  // deleteTemplateData:[],
}

// fetch the all primary diagnosis list 
export const fetchTemplates = createAsyncThunk(
    'bmr/fetchTemplates',
    async (params, { rejectWithValue }) => {
        try {
            const response = await api.get('/ftb/templates/list', { params: params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

//Create Form Template API
export const addTemplate = createAsyncThunk(
  'bmr/addTemplate',
  async (args, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post('/ftb/templates/create', args);
      dispatch(disableModal())
      dispatch(fetchTemplates());
      return response.data;
    } catch (error) {
      return rejectWithValue(error || error?.response?.data?.message || error?.response?.message || error?.message || "Something went wrong"
      );
    }
  }
);

// @info handle thunk for duplicate template.
export const duplicateTemplate = createAsyncThunk(
    'bmr/duplicateTemplate',
    async ({id,payload}, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post(`/ftb/templates/${id}/duplicate`, payload);
            notify.success(response.data.message);
            dispatch(disableModal())
            dispatch(fetchTemplates());
            return response.data;
        } catch (error) {
          return rejectWithValue(error||
            error?.response?.data?.message || error?.response?.message || error?.message || "Something went wrong"
          )
        }
    }
);

// Check Template existence. 
export const templateExist = createAsyncThunk(
    'bmr/templateExist',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/ftb/templates/existing');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Dropdown of the template with versions 
export const templateDropdown = createAsyncThunk(
    'bmr/templateDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/ftb/templates/dropdown');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const deleteTemplate = createAsyncThunk(
    'bmr/deleteTemplate',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/ftb/templates/${id}/delete`);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// @info fetch the maximum version of all over templates.
export const fetchAllVersions = createAsyncThunk(
    'bmr/fetchAllVersions',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/ftb/templates/max-template-version');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// /ftb/templates/timeline/33
export const fetchTimeLine = createAsyncThunk(
    'bmr/fetchTimeLine',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/ftb/templates/timeline/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
// @info published template version increment
export const incrementVersion = createAsyncThunk(
    'bmr/incrementVersion',
    async ( id, { rejectWithValue }) => {
        try {
            const response = await api.post(`/ftb/templates/${id}/increment-version`);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);



const bmrFbTemplateSlice = createSlice({
  name: 'bmrFbl',
  initialState,
  reducers: {
    enableModal(state) {
      state.addModal = true;
    },
    disableModal(state) {
      state.addModal = false;
    },enableClonedModal(state) {
      state.clonedModal = true;
    },
    disableClonedModal(state) {
      state.clonedModal = false;
    },
    updateTemplateStatus: (state, action) => {
      const { id, status } = action.payload;
      if (state.fbTemplate.items && Array.isArray(state.fbTemplate.items)) {
        const templateIndex = state.fbTemplate.items.findIndex(item => item.id === id);
        if (templateIndex !== -1) {
          state.fbTemplate.items[templateIndex].status = status;
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTemplate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addTemplate.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addTemplate.rejected, (state) => {
        state.isLoading = false;
      })
      //@info here duplicate template thunk
    builder
      .addCase(duplicateTemplate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(duplicateTemplate.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(duplicateTemplate.rejected, (state) => {
        state.isLoading = false;
      })

        builder
      .addCase(fetchTemplates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.isLoading = false;
        const { items, pagination } = action.payload.data;

        if (pagination.page === 1) {
          state.fbTemplate.items = items;  // first page -> replace
        } else {
          state.fbTemplate.items = [...state.fbTemplate.items, ...items]; // next pages -> append
        }

        state.fbTemplate.pagination = pagination;
      })
      .addCase(fetchTemplates.rejected, (state) => {
        state.isLoading = false;
      })

    builder
      .addCase(templateExist.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(templateExist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.templateExit = action.payload.data;
      })
      .addCase(templateExist.rejected, (state) => {
        state.isLoading = false;
      })
      
    builder
      .addCase(templateDropdown.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(templateDropdown.fulfilled, (state, action) => {
        state.isLoading = false;
        state.templateDropdownlist = action.payload.data;
      })
      .addCase(templateDropdown.rejected, (state) => {
        state.isLoading = false;
      })

    builder
      .addCase(deleteTemplate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteTemplate.fulfilled, (state,action) => {
        state.isLoading = false;
        const deleteid=action.meta.arg;
        state.fbTemplate
        state.fbTemplate.items=state.fbTemplate.items.filter((item)=>item.id !== deleteid)
        // state.deleteTemplateData = action.payload.data;
      })
      .addCase(deleteTemplate.rejected, (state) => {
        state.isLoading = false;
      })
      
      builder
      .addCase(fetchAllVersions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllVersions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.versions=action.payload.data;
      })
      .addCase(fetchAllVersions.rejected, (state) => {
        state.isLoading = false;
      })

    //@info fetch timeline here.
    builder
      .addCase(fetchTimeLine.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTimeLine.fulfilled, (state, action) => {
        state.isLoading = false;
        state.timeline = action.payload.data;
      })
      .addCase(fetchTimeLine.rejected, (state) => {
        state.isLoading = false;
      });
      //@info increment version of template.
      builder
      .addCase(incrementVersion.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(incrementVersion.fulfilled, (state,action) => {
        state.isLoading = false;
        state.incrementTemplateData=action.payload;
      })
      .addCase(incrementVersion.rejected, (state) => {
        state.isLoading = false;
      });
  }
});
export const { updateTemplateStatus } = bmrFbTemplateSlice.actions;
export const { enableModal, disableModal,enableClonedModal ,disableClonedModal } = bmrFbTemplateSlice.actions;
export const isTemplateModal = (state) => state?.bmrFbl?.addModal;
export const isClonedModal = (state) => state?.bmrFbl?.clonedModal;

export default bmrFbTemplateSlice.reducer;
  